import React from 'react';
import { useSelector } from 'react-redux';

import { UiFullScreenLoader } from 'src/components/UI/loaders/FullScreenTransparent';
import { showGlobalLoaderSelector } from 'src/store/commonPart/selector';

export const GlobalLoader: React.FC = () => {
  const show = useSelector(showGlobalLoaderSelector);

  return show ? <UiFullScreenLoader /> : null;
};
